import { post,put,del,get,get2 } from './axios'

// 관리자관리 CRUD를 나열
export const userLogin = async (params) => {
    const { status, data } = await post("/user/login", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const userJoin = async (params) => {
    const { status, data } = await post("/user/join", params)

    if (status === 200 || status === 201) {
        return data
    }
}

export const findID = async (params) => {
  const { status, data } = await post("/user/findID", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const findPW = async (params) => {
  const { status, data } = await post("/user/findPW", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const findUpdatePW = async (params) => {
  const { status, data } = await post("/user/findUpdatePW", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const getAdminMemberVueList = async (params) => {
    const { status, data } = await get("/user/userAdminList", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const getMemberVueList = async (params) => {
  const { status, data } = await get("/user/userList", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const updateMemberState = async (params) => {
  const { status, data } = await get("/user/updateState", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const deleteMember = async (params) => {
  const { status, data } = await del("/user/delete", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const sendUserEmail = async (params) => {
  const { status, data } = await post("/user/sendMail", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const sendAdminEmail = async (params) => {
  const { status, data } = await post("/user/sendAdminMail", params);

  if (status === 200 || status === 201) {
    return data;
  }
};


export const userPwInit = async (params) => {
  const { status, data } = await post("/user/pwInit", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const ApprovedStandardList = async (params) => {
  const { status, data } = await post("/user/userApprovedStandard", params);
  if (status === 200 || status === 201) {
    return data;
  }
};

export const ApprovedStandardUpdate = async (params) => {
  const { status, data } = await post("/user/updateApprovedStandard", params);
  if (status === 200 || status === 201) {
    return data;
  }
};

export const checkUpdateApprovedStandardBeFor = async (params) => {
  const { status, data } = await post("/user/checkUpdateApprovedStandardBeFor", params);
  if (status === 200 || status === 201) {
    return data;
  }
};

export const updateAppStanList = async (params) => {
  const { status, data } = await post("/user/updateAppStanList", params);
  if (status === 200 || status === 201) {
    return data;
  }
};

export const loginApprovedStandard = async (params) => {
  const { status, data } = await post("/user/loginApprovedStandard", params);
  if (status === 200 || status === 201) {
    return data;
  }
};

export const updateApprovedStandardBeFor = async (params) => {
  const { status, data } = await post("/user/updateApprovedStandardBeFor", params);
  if (status === 200 || status === 201) {
    return data;
  }
};

export const getUserMyPage = async (params) => {
  const { status, data } = await get("/user/userMyPage", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const getOrgInUser = async (params) => {
  const { status, data } = await get("/user/orgInUser", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const selectVisitorCount = async (params) => {
  const { status, data } = await get("/user/selectVisitorCount", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const updateVisitorCount = async (params) => {
  const { status, data } = await post("/user/updateVisitorCount", params)

  if (status === 200 || status === 201) {
      return data
  }
}